import { ref as P, onMounted as T, watchEffect as W, onBeforeUnmount as y } from "vue";
import { addUnit as w } from "./index641.js";
const U = (n, u, M, h) => {
  const o = {
    offsetX: 0,
    offsetY: 0
  }, a = P(!1), g = (t, e) => {
    if (n.value) {
      const { offsetX: f, offsetY: l } = o, s = n.value.getBoundingClientRect(), i = s.left, c = s.top, m = s.width, d = s.height, v = document.documentElement.clientWidth, L = document.documentElement.clientHeight, x = -i + f, D = -c + l, b = v - i - m + f, H = L - c - (d < L ? d : 0) + l;
      h?.value || (t = Math.min(Math.max(t, x), b), e = Math.min(Math.max(e, D), H)), o.offsetX = t, o.offsetY = e, n.value.style.transform = `translate(${w(t)}, ${w(
        e
      )})`;
    }
  }, p = (t) => {
    const e = t.clientX, f = t.clientY, { offsetX: l, offsetY: s } = o, i = (m) => {
      a.value || (a.value = !0);
      const d = l + m.clientX - e, v = s + m.clientY - f;
      g(d, v);
    }, c = () => {
      a.value = !1, document.removeEventListener("mousemove", i), document.removeEventListener("mouseup", c);
    };
    document.addEventListener("mousemove", i), document.addEventListener("mouseup", c);
  }, X = () => {
    u.value && n.value && (u.value.addEventListener("mousedown", p), window.addEventListener("resize", r));
  }, E = () => {
    u.value && n.value && (u.value.removeEventListener("mousedown", p), window.removeEventListener("resize", r));
  }, Y = () => {
    o.offsetX = 0, o.offsetY = 0, n.value && (n.value.style.transform = "");
  }, r = () => {
    const { offsetX: t, offsetY: e } = o;
    g(t, e);
  };
  return T(() => {
    W(() => {
      M.value ? X() : E();
    });
  }), y(() => {
    E();
  }), {
    isDragging: a,
    resetPosition: Y,
    updatePosition: r
  };
};
export {
  U as useDraggable
};
